import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import {
  add_feed_comment,
  edit_feed_comment,
} from "src/DAL/Community/Comments";
import { s3baseUrl } from "src/config/config";
import CommentComposer from "src/components/CommunityFeed/CommentComposer";

export default function AddComment({
  post_id,
  formAction,
  setFormAction,
  setShowAddComment,
  handleUpdateSpecificFeed,
  commentSelected,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState("");
  const [commentId, setCommentId] = useState("");
  const [image, setImage] = React.useState("");
  const [previews, setPreviews] = useState("");
  const [oldImage, setOldImage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("feed", post_id);
    formData.append("text", state);
    if (image) {
      formData.append("comment_image", image);
    }
    if (state == "" && !image) {
      enqueueSnackbar("At least  add Text or an Image in Comment", {
        variant: "error",
      });
    } else {
      setIsLoading(true);
      const result = await add_feed_comment(formData);
      if (result.code === 200) {
        handleRemove();
        handleUpdateSpecificFeed(post_id);
        setState("");
        setIsLoading(false);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("text", state);
    if (oldImage || image) {
      if (image) {
        formData.append("comment_image", image);
        formData.append("is_cancelled", false);
      } else if (commentSelected.comment_image?.thumbnail_1) {
        formData.append("is_cancelled", false);
      }
    } else {
      formData.append("is_cancelled", true);
    }
    if (state == "" && !image && !oldImage) {
      enqueueSnackbar("At least  add Text or an Image in Comment", {
        variant: "error",
      });
    } else {
      setIsLoading(true);
      const result = await edit_feed_comment(formData, commentId);
      if (result.code === 200) {
        handleUpdateSpecificFeed(post_id);
        handleRemove();
        setState("");
        setIsLoading(false);
        setFormAction("ADD");
        setShowAddComment(false);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    }
  };

  const handleRemove = () => {
    setPreviews("");
    setOldImage("");
    setImage("");
  };

  const handlePickImage = (file) => {
    setImage(file);
    setPreviews(URL.createObjectURL(file));
  };

  const handleCancelUpdate = (e) => {
    e.preventDefault();
    setState("");
    setFormAction("ADD");
    setShowAddComment(false);
  };

  useEffect(() => {
    if (formAction === "EDIT") {
      setState(commentSelected.text);
      setCommentId(commentSelected._id);
      if (commentSelected.comment_image?.thumbnail_1) {
        setOldImage(commentSelected.comment_image?.thumbnail_1);
      }
    }
  }, [formAction]);

  return (
    <CommentComposer
      value={state}
      setValue={setState}
      onSubmit={formAction === "ADD" ? handleSubmit : handleUpdate}
      loading={isLoading}
      editing={formAction === "EDIT"}
      onCancel={handleCancelUpdate}
      imageSrc={previews || (oldImage ? s3baseUrl + oldImage : "")}
      onPickImage={handlePickImage}
      onRemoveImage={handleRemove}
      autoFocus
    />
  );
}
